<template>
    <div class="content-window">
        <div class="news-grid">
            <div class="news-header">
                <div v-html="getText('March 28, 2025: New single out now!')"/> 
            </div>

            <div class="news-cover">
                <img src="AlbumCovers/All I recall cover.svg">
            </div>

            <div class="news-stream1">
                <a href="https://open.spotify.com/intl-de/track/5NHe6HsHtfZbbk91egCiT8?si=e6a146e5277047b9" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Spotify_black.svg"></div>
                        <div v-html="getText(' stream on spotify')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream2">
                <a href="https://music.apple.com/us/album/all-i-recall/1799166456?i=1799166457" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/AppleMusic.svg"></div>
                        <div v-html="getText(' stream on Apple Music')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream3">
                <a href="https://music.amazon.com/tracks/B0DYV6WGKX?marketplaceId=A1PA6795UKMFR9&musicTerritory=DE&ref=dm_sh_GWjDIlDTl4pUxD6VHl171CoIF" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Amazon.svg"></div>
                        <div v-html="getText(' stream on Amazon')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream4">
                <a href="https://music.youtube.com/playlist?list=OLAK5uy_m6OrruC1mHCE8GMLaQ8QXbALzfJM9MHHw&si=3cUKb8ojHzTPp_cD" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Youtube.svg"></div>
                        <div v-html="getText(' stream on Youtube Music')"/> 
                    </div>
                </a>
            </div>

            <div class="news-stream5">
                <a href="https://dzr.page.link/RjTwe2C3Mzj1QQd7A" target="_blank">
                    <div class="news-text">
                        <div class="news-text-logo"><img src="Logos/Deezer.svg"></div>
                        <div v-html="getText(' stream on Deezer')"/> 
                    </div>
                </a>
            </div>

        </div>

    </div>

</template>

<script>
    import helpers from '../../helpers/helpers.js';

    export default {
        name: 'NewsComponent2',
        data() {
            return {
                buttonClicked: null
            }
        },
        methods: {
            getText(text) {
                return helpers.textToCSV(text);
            },
            clickButton(buttonClicked) {
                this.clickedButton = buttonClicked;
            },
        }
    }
</script>

